import constants from '../constants';
import getCalculatedSiteSetupStepsMap from './get-calculated-site-setup-steps-map';

const { siteSetupNames } = constants;

const getCurrentStep = () => {
  const siteSetupStepsMap = getCalculatedSiteSetupStepsMap();
  let pathName;

  Object.values(siteSetupNames).forEach((item) => {
    if (pathName) return;
    pathName = window.location.pathname.split('/').find((step) => step === item);
  });

  const number = siteSetupStepsMap[pathName];

  return {
    number,
    stepName: pathName,
  };
};

export default getCurrentStep;
